import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";
import PostDataComplex from '../../services/PostDataComplex';
import PostData from '../../services/PostData';

const CreateNewPassword = () => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);
  
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [selector, setSelector] = useState(null);
  const [validator, setValidator] = useState(null); 
  const [tokensChecked, setTokensChecked] = useState(false); 

  const [formData, setFormData] = useState({ 
      password: "",
      confirmedPassword: "",
    }
  );

  function handleChange(event) {
    const { name, value, type, checked } = event.target
    setFormData(prevState => {
      return{
        ...prevState,
        // [event.target.name]: event.target.value
        [name]: type === "checkbox" ? checked : value
      }
    });
  };

  useEffect(()=>{
    const selector = getQueryVariable('selector');
    const validator = getQueryVariable('validator');

    setSelector(selector);
    setValidator(validator);
    // console.log(`token: ${token}`);

    const data = {
      selector: selector,
      validator: validator
    }

    ctype_xdigit(data);

  },[]);

  const getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] == variable){
        return pair[1];
      }
    }
  }

  const ctype_xdigit = (data) => {
    console.log('ctype_xdigit()');

    console.log('data:->');
    console.log(data);

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);
    
    if( localHost || network) {
      console.log('LOCALE!!!');

      setTokensChecked(true);
      setErrorMessage('');


    } else {

      PostDataComplex('users_manager', 'POST', 'ctype_xdigit', data)
        .then((response) => {
          console.log('response.data:->');
          console.log(response.data);
          
          const ctype_xdigit_check = response.data.feedBack.ctype_xdigit_check;
          setTokensChecked(ctype_xdigit_check);
          console.log(`ctype_xdigit_check ${ctype_xdigit_check}`);

        }
      )
    }
  }

  const handleResetPassword = (e) => {
    console.log('handleResetPassword()');

    e.preventDefault();

    const data = {
      selector: selector,
      validator: validator,
      password: formData.password,
      confirmedPassword: formData.confirmedPassword,
    }
    console.log('data:->');
    console.log(data);

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);

    setMessage('');
    setErrorMessage('');
    
    if( localHost || network) {
      console.log('LOCALE!!!')

      if(false) {
        console.log('Password reset successfully!!!');
        setMessage('password reset successfully!!!');
      } else {
        console.log('no selector still valid found');
        setErrorMessage('no selector still valid found');
      }
          

    } else {

      // PostData('POST', 'resetPassword', data)
      PostDataComplex('users_manager', 'POST', 'resetPassword', data)
        .then((response) => {
          console.log('resetPassword response.data:->');
          console.log(response.data);

          const resetPasswordData = response.data.feedBack.resetPasswordData.resetPasswordResult;

          if(resetPasswordData.passwordreset) {
            console.log('Password reset successfully!!!');
            setMessage('password reset successfully!!!');
            
          } else {
            console.log('Password reset  error!!!');
            console.log(resetPasswordData.error);
            setErrorMessage(resetPasswordData.error);
          }
        }
      )

    }
  }


  return (
    <Wrapper id="create-new-password--wrapper">
      {/* <Header>SignIn</Header> */}
      <Container id="create-new-password--container">
        <Content className="create-new-password--content">
          <ContentHeader className="create-new-password--content-header">
            PictureViewer
            <span>by rndWs.com</span>
          </ContentHeader>
          {!tokensChecked &&
            <Title style={{color: 'red', fontSize: '1.4rem'}} className="create-new-password--title">
              Could not validate your request
              {/* <span>for <Link to={BASE_URL + "/login"}>Login PictureViewer</Link></span> */}
            </Title>
          }
          {!tokensChecked &&
            <ButtonBelly className="create-new-password--button-belly">
              <Link to={BASE_URL +"/login"}>Back to login</Link>
              <span><Link to={BASE_URL + "/forgot-password"}>Reset your password?</Link></span>
            </ButtonBelly>
          }

          {tokensChecked && 
            <Title>
              Create New Password
              {/* <span>Already a member? <Link to={BASE_URL + "/login"}>Login PictureViewer</Link></span> */}
            </Title>
          }
          {tokensChecked &&
            (!message && !errorMessage) ? (
              <Form>
                <Input 
                  placeholder="Enter a new password..."
                  id="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  name="password"
                />
                <Input 
                  placeholder="Confirm the new password..."
                  id="confirmedPassword"
                  type="password"
                  value={formData.confirmedPassword}
                  onChange={handleChange}
                  name="confirmedPassword"
                />
                <Button onClick={handleResetPassword}>Reset password</Button>
              </Form> 
            ) : (
              <Messages>
                {message &&<Message>{message}</Message>}
                {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
              </Messages>
            )
          }
          {tokensChecked &&
            <ButtonBelly className="create-new-password--button-belly">
              {errorMessage && <span><Link to={BASE_URL + "/forgot-password"}>Reset your password?</Link></span> }
              <span><Link to={BASE_URL +"/login"}>Back to login</Link></span>
            </ButtonBelly>
          }
          
        </Content>
      </Container>
    </Wrapper>
  )
}

export default CreateNewPassword;

const Wrapper = styled.div `
  width: 100%;
  min-height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div `
  /* text-align: center; */
`;

const Container = styled.div `
  /* width: 400px; */
  /* max-width: 400px;  */
`;
const Content = styled.div `
  border: 1px solid orange;
  padding-bottom: 2rem;
  background-color: rgba(0,0,0,0.4);
`;
const ContentHeader = styled.div `
  display: flex;
  flex-direction: column;

  text-align: center;
  background-color: #111;
  padding: 2rem 3rem;
  line-height: 1.3rem;

  span {
    font-size: 1rem;
  }
`;
const Title = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 1.6rem;
  padding: 1rem 2.4rem;

  span {
    font-size: 1rem;

    a {
      color: #3e85f5;
    }
  }

`;

const Form = styled.form `
  display: flex;
  flex-direction: column;
  
  padding: 1rem .5rem;

`;
const Input = styled.input `
  border: 1px solid #1b1b1b;
  background-color: #0e0e0e;
  font-size: 1.1rem;
  margin-top: .2rem;
  padding: 1rem .8rem;
  color: #d1d1d1;

`;
const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;

  cursor: pointer;
`;


const Messages = styled.div `
  font-size: 1.6rem;
  padding: 1rem .8rem;
  text-align: center;
  height: 2rem;   
  margin-bottom: 2rem;;
`;

const Message = styled.div `
  /* font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  height: 1rem; */
  color: green;
  /* border: 1px solid orange; */
  
`;
const ErrorMessage = styled.div `
  /* font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  height: 1rem; */
  color: red;
  /* border: 1px solid orange; */
  
`;

const ButtonBelly = styled.div `
  font-size: .7rem;
  padding: 1rem .8rem;
  text-align: center;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  span {
    font-size: .9rem;
    color: #029F85;
  }
`;




